import React from 'react';
import MaterialTable from 'material-table';
import { t } from 'ttag';
import useApi from '../../api';
import { useQuery } from '@apollo/react-hooks';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { localization } from '../DataTable/utils';
import Dialog from '@material-ui/core/Dialog';
import TwoOptionAlert from '../TwoOptionAlert';

function AthleteGroupChangeDialog({ currentGroupId, handleChangeGroup }) {
  const api = useApi();
  const [state, setState] = React.useState({
    changeGroupAlert: false,
    newGroup: null,
  });
  const [getGroupsQuery, key] = api.schema.groups.many();
  const { loading, data } = useQuery(getGroupsQuery, {
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return (
      <Backdrop open>
        <CircularProgress />
      </Backdrop>
    );
  }

  const cleanData = data[key].filter((group) => group.id !== currentGroupId);

  return (
    <>
      {state.changeGroupAlert && (
        <Dialog
          open={state.changeGroupAlert}
          onClose={() => {
            setState({ ...state, changeGroupAlert: false });
          }}
          aria-labelledby='alert-dialog-title'
        >
          <TwoOptionAlert
            titleText={'Перевести і зберегти?'}
            cancelText={'Ні'}
            confirmText={'Так'}
            onConfirm={() => {
              handleChangeGroup(state.newGroup.id);
              setState({ changeGroupAlert: false, newGroup: null });
            }}
            onCancel={() => {
              setState({ changeGroupAlert: false, newGroup: null });
            }}
          />
        </Dialog>
      )}
      <MaterialTable
        toolbar={false}
        localization={localization}
        title={'Виберіть групу'}
        columns={[
          { title: t`Id`, field: 'id', editable: 'never' },
          { title: t`Назва`, field: 'name', editable: 'never' },
          { title: t`Зал`, field: 'gym.name', editable: 'never' },
          { title: t`Тренер`, field: 'trainer.fullName', editable: 'never' },
        ]}
        data={cleanData}
        actions={[
          {
            icon: 'doneRounded',
            tooltip: 'Перевести спортсмена',
            onClick: (event, rawData) => {
              setState({ ...state, changeGroupAlert: true, newGroup: rawData });
            },
          },
        ]}
        options={{
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
}

export default AthleteGroupChangeDialog;
